<div class="input-component"
  [ngClass]="{'pristine': pristine, 'valid': (validStatus$ | async), 'invalid': (invalidStatus$ | async), 'disabled': disabled}">
  <div class="input-wrapper">
    <div class="input-textarea-text">
      <textarea [disabled]="notEnabled" type="text" class="input-field" [attr.required]="required" [(ngModel)]="value"
        [id]="fieldId" [name]="name" [attr.innerText]="value" [ngModelOptions]="updateOn"
        placeholder="{{ placeholder }}" class="textarea" [rows]="rows" [maxlength]="maxlength"
        >
      </textarea>
      <label [attr.for]="fieldId">{{label}}</label>
    </div>
    <div class="input-textarea-validation">
      @if (dirty) {
        <div class="input-validation fa-stack fa-1x">
          <i class="fas fa-stack-2x fa-circle" aria-hidden="true"></i>
          <i class="fal fa-stack-1x" [ngClass]="(validStatus$ | async) ? 'fa-check' : 'fa-times'"
          aria-hidden="true"></i>
        </div>
      }
    </div>
  </div>
  <aa-validation2 [dirty]="dirty" [messages]="failures | async">
  </aa-validation2>
</div>
